import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './components/App';
import reportWebVitals from './reportWebVitals';

const missingTranslation = 'MISSING_TRANSLATION';
const consoleErr = console.error.bind(console);
console.error = (msg, ...args) => {
  // disable MISSING_TRANSLATION errors output in console
  if (msg.code && msg.code === missingTranslation) {
    return;
  }
  consoleErr(msg, ...args);
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
